import axios from 'settings/axios'
import { apiEndpoints } from 'settings/_apiSettings'
import { Address } from 'models/Auth'


export async function getAddressByCEP(cep: string): Promise<Address> {
  return axios.get(apiEndpoints.EXTERNAL_SERVICES_ADDRESS(cep))
}
